
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexJPgmH1AIMQPUKo3Gisn8zmzNtZEMXnRIxEsqrUYMOo0Meta } from "/home/ubuntu/front-cabo-de-guerra/pages/index.vue?macro=true";
import { default as lobbygeo0LD4jflKcelXbYKY2ynnIaycj29yZRo981Q4qI7UMeta } from "/home/ubuntu/front-cabo-de-guerra/pages/lobby.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/home/ubuntu/front-cabo-de-guerra/pages/index.vue")
  },
  {
    name: "lobby",
    path: "/lobby",
    component: () => import("/home/ubuntu/front-cabo-de-guerra/pages/lobby.vue")
  }
]